// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__3qmb0","clickable":"Table_clickable__2k78Z"};